import { useEffect, useRef, useState } from '@wordpress/element';
const $ = jQuery;

const Portfolio = ({ attributes, clientId, isBackend = false, custom = {} }) => {
	const { categories, portfolios, columns, columnGap, rowGap, background, padding, border, filterBtnTypo, filterBtnColors, filterBtnHoverColors, itemHeight, itemHoverEffect, isLink, titleStyle, titleBG, titleTypo, titleColor } = attributes;

	const [itemWidth, setItemWidth] = useState('');
	const pfbColumn = useRef(null);

	useEffect(() => {
		setItemWidth(pfbColumn.current.clientWidth);
	}, [pfbColumn.current, columns, columnGap, rowGap]);

	useEffect(() => {
		const isoOptions = {
			filter: '*',
			itemSelector: '.galleryItem',
			masonry: {
				fitWidth: true, // When enabled, you can center the container with CSS.
				gutter: columnGap
			},
			stagger: 30,
			transitionDuration: '0.5s'
		}

		const pfbIso = $(`#gallery-${clientId}`).isotope(isoOptions);
		pfbIso.isotope('destroy');
		pfbIso.isotope(isoOptions);

		// Filter items on button click
		$(`#filter-${clientId}`).on('click', 'button', function () {
			$(`#filter-${clientId} .current`).removeClass('current');
			$(this).addClass('current');

			const filterValue = $(this).attr('data-filter');
			pfbIso.isotope({ ...isoOptions, filter: filterValue });
		});
	}, [portfolios?.length, columns, columnGap, rowGap, itemWidth, itemHeight]);

	// FancyBox set
	useEffect(() => {
		!isBackend && $('.galleryItem').fancybox({
			baseClass: `pfbFancyBox pfbFancyBox-${clientId}`,
			buttons: [
				'slideShow',
				// 'thumbs',
				// 'zoom',
				// 'fullScreen',
				// 'share',
				'close'
			],
			loop: false,
			protect: true
		});
	}, []);

	return <>
		<style dangerouslySetInnerHTML={{
			__html: `
			${filterBtnTypo?.googleFontLink ? `@import url(${filterBtnTypo?.googleFontLink});` : ''}
			${titleTypo?.googleFontLink ? `@import url(${titleTypo?.googleFontLink});` : ''}

			#pfbPortfolio-${clientId} .pfbPortfolio{
				${background?.styles || 'background: #fff;'}
				padding: ${padding?.styles || '10px 10px'};
				${border?.styles || 'border-radius: 5px;'}
				box-shadow: 0px 25px 30px -20px rgba(0, 0, 0, 0.2);
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .filter button{
				${filterBtnTypo?.styles || 'font-size: 14px;'}
				${filterBtnColors?.styles || 'color: #fff; background: #4527a4;'}
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .filter button:hover, #pfbPortfolio-${clientId} .pfbPortfolio .filter button.current{
				${filterBtnHoverColors?.styles || 'color: #fff; background: #8344c5;'}
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .pfbColumnSizer {
				grid-column-gap: ${columnGap}px;
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .gallery .galleryItem{
				width: ${itemWidth}px;
				height: ${itemHeight};
				margin-bottom: ${rowGap}px;
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .galleryItem figcaption{
				${titleBG?.styles || 'background-color: #0006;'}
				${isBackend && custom.isTitleEdit ? 'opacity: 1;' : ''}
			}
			#pfbPortfolio-${clientId} .pfbPortfolio .galleryItem figcaption p{
				${titleTypo?.styles || 'font-size: 22px;'}
				color: ${titleColor};
			}
			.pfbFancyBox-${clientId} .fancybox-caption__body a{
				display: ${isLink ? 'inline-flex' : 'none'};
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 24 24' fill='%23ffffff'%3E%3Cpath d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z' /%3E%3C/svg%3E");
			}
			.pfbFancyBox-${clientId} .fancybox-caption__body a:hover{
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20px' height='20px' viewBox='0 0 24 24' fill='%23a78bff'%3E%3Cpath d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8z' /%3E%3C/svg%3E");
			}
			`.replace(/\s+/g, ' ')
		}} />

		<div className='pfbPortfolio'>
			<div id={`filter-${clientId}`} className='filter'>
				<button data-filter='*' className='current'>All Categories</button>
				{categories?.map(cat => <button key={lodash.camelCase(cat)} data-filter={`.${lodash.camelCase(cat)}`}>{cat}</button>)}
			</div>

			<div className={`pfbColumnSizer columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}`}>
				<div className='pfbColumn' ref={pfbColumn}></div>
			</div>

			<div id={`gallery-${clientId}`} className='gallery'>
				{portfolios?.map((item, index) => {
					const { image, title, link, cats } = item;

					return isBackend ? <div
						onClick={() => isBackend && custom.setActiveIndex(index)}
						className={`galleryItem ${cats?.map(c => lodash.camelCase(c)).join(' ')} ${index === custom.activeIndex ? 'pfbNowEditing' : ''}`}
					>
						<figure className={`galleryFigure ${itemHoverEffect}`}>
							<img src={image?.url} alt={image?.alt || image?.title} />
							{<figcaption className={titleStyle}><p>{title}</p></figcaption>}
						</figure>
					</div> : <a
						key={index}
						className={`galleryItem ${cats?.map(c => lodash.camelCase(c)).join(' ')}`}
						data-fancybox={`fancybox-${clientId}`}
						href={isBackend ? '' : image?.url}
						data-caption={`${title} <a href='${link}'></a>`}
					>
						<figure className={`galleryFigure ${itemHoverEffect}`}>
							<img src={image?.url} alt={image?.alt || image?.title} />
							{<figcaption className={titleStyle}><p>{title}</p></figcaption>}
						</figure>
					</a>;
				})}
			</div>
		</div>
	</>
}
export default Portfolio;